import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
const Layout = () => import(/* webpackChunkName:"layout" *//* webpackMode: "lazy" */'@/layout/index.vue')
export const constantRoutes = [
  {
    path: '/',
    component: Layout,

    children: [
      {
        path: '/',
        component: () => import(/* webpackChunkName:"browser" *//* webpackMode: "lazy" */'@/views/Browser/index.vue'),
        name: 'blockBrowser'
      },
      {
        path: 'viewer/*',
        component: () => import(/* webpackChunkName:"viewer" *//* webpackMode: "lazy" */'@/views/Viewer/index.vue'),
        name: 'blockViewer'
      },
      {
        path: 'original/*',
        component: () => import(/* webpackChunkName:"viewer" *//* webpackMode: "lazy" */'@/views/Transaction/index.vue'),
        name: 'transactionViewer'
      },
      {
        path: '404',
        component: () => import(/* webpackChunkName:"viewer" *//* webpackMode: "lazy" */'@/views/404/index.vue'),
        name: '404'
      }
    ]
  }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
